import { useState } from 'react'
import { Alert, AlertTitle, Button, CircularProgress, Container, Paper, Stack, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import {
    CONTACT_VERIFICATION_EMAIL_KEY,
    CONTACT_VERIFICATION_EMAIL_VALIDATED_KEY,
    CONTACT_VERIFICATION_ENTRY_TOKEN_KEY,
    CONTACT_VERIFICATION_IDENTITY_DATA_KEY,
    CONTACT_VERIFICATION_PHONE_KEY,
    CONTACT_VERIFICATION_PHONE_VALIDATED_KEY,
    CONTACT_VERIFICATION_PROCESS_STATUS_KEY,
    CONTACT_VERIFICATION_TOKEN_KEY,
    CONTACT_VERIFICATION_VAT_KEY,
    setItemToLS,
    useStartContactVerificationProcess,
} from '../../core/api'

export default function VerificationCard({ verificationToken }) {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const startVerification = useStartContactVerificationProcess()
    const [vat, setVat] = useState('')
    const [error, setError] = useState('')

    async function handleSubmit(event) {
        event.preventDefault()

        try {
            const session = await startVerification.mutateAsync({ verificationToken, vat: vat.trim().toUpperCase() })
            setError('')
            setItemToLS(CONTACT_VERIFICATION_ENTRY_TOKEN_KEY, verificationToken)
            setItemToLS(CONTACT_VERIFICATION_TOKEN_KEY, session.token)
            setItemToLS(CONTACT_VERIFICATION_VAT_KEY, vat.trim().toUpperCase())
            setItemToLS(CONTACT_VERIFICATION_EMAIL_KEY, '')
            setItemToLS(CONTACT_VERIFICATION_PHONE_KEY, '')
            setItemToLS(CONTACT_VERIFICATION_IDENTITY_DATA_KEY, null)
            setItemToLS(CONTACT_VERIFICATION_EMAIL_VALIDATED_KEY, false)
            setItemToLS(CONTACT_VERIFICATION_PHONE_VALIDATED_KEY, false)
            setItemToLS(CONTACT_VERIFICATION_PROCESS_STATUS_KEY, null)
            navigate(`/verify/${verificationToken}/email`)
        } catch (err) {
            const message = err?.response?.data?.message || err.message || t('verification.startError')
            setError(message === 'API_URL not configured' ? t('verification.apiNotConfigured') : message)
        }
    }

    return (
        <Container maxWidth="sm" sx={{ py: { xs: 3, md: 5 }, flexGrow: 1 }}>
            <Paper variant="outlined" sx={{ p: { xs: 3, md: 4 } }}>
                <Stack component="form" spacing={2.5} onSubmit={handleSubmit}>
                    <Stack spacing={1.25}>
                        <Typography variant="h3" gutterBottom>
                            {t('verification.title')}
                        </Typography>
                        <Alert severity="info">
                            <AlertTitle>{t('verification.reviewImportantTitle')}</AlertTitle>
                            {t('verification.reviewImportantDescription')}
                        </Alert>
                        <Typography color="text.secondary">{t('verification.description')}</Typography>
                    </Stack>
                    {error ? <Alert severity="error">{error}</Alert> : null}
                    <TextField
                        autoComplete="off"
                        fullWidth
                        label={t('verification.vatLabel')}
                        name="vat"
                        onChange={(event) => setVat(event.target.value)}
                        required
                        value={vat}
                    />
                    <Button loading={startVerification.isPending} type="submit" variant="contained" color="primary">
                        {startVerification.isPending ? <CircularProgress color="inherit" size={20} /> : t('verification.start')}
                    </Button>
                </Stack>
            </Paper>
        </Container>
    )
}
